import { render, staticRenderFns } from "./DeleteTeamModal.vue?vue&type=template&id=812a3c36&"
import script from "./DeleteTeamModal.vue?vue&type=script&lang=js&"
export * from "./DeleteTeamModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports